<template>
  <v-app>
    <AppNav />
    <v-main class="mt-4 pt-8">
      <RouterView />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import axios from "axios";
import AppNav from "@/components/AppNav";
import Footer from "@/components/Footer";
import store from "@/store";

const userString = localStorage.getItem("user");
if (userString) {
    const content = JSON.parse(userString);
    store.commit("users/SET_USER_DATA", content);
}

const cookiesString = localStorage.getItem("cookies");
if (cookiesString) {
    const content = JSON.parse(cookiesString);
    store.commit("cookies/SET_COOKIES", content);
}

export default {
    name: "App",

    components: { AppNav, Footer },

    metaInfo: {
        titleTemplate: "%s | Trabajo con Sentido"
    },

    created() {
        // Se obtienen valores de listas
        this.$store.dispatch("fixtures/get");
        axios.interceptors.response.use(
            response => response, // simply return the response
            error => {
                if (error.response.status === 401) {
                    // if we catch a 401 error
                    this.$store.dispatch("logout"); // force a log out
                }
                return Promise.reject(error); // reject the Promise, with the error as the reason
            }
        );
    }
};
</script>
